import React from "react";
import { Alert, AlertDescription } from "./ui/alert";

export const ErrorState = ({ error, onClearError }) => {
  return (
    <div className="flex flex-col h-full">
      <Alert className="mx-6 mt-2 border-red-500 bg-red-50">
        <AlertDescription className="text-red-700 flex justify-between items-center">
          <span>{error}</span>
          <button
            onClick={onClearError}
            className="ml-2 text-red-500 hover:text-red-700 font-bold"
          >
            ×
          </button>
        </AlertDescription>
      </Alert>
    </div>
  );
};
